import { StepBack } from 'lucide-react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { ROUTES } from '@/routes';

const BACK_NAV_CLASSES = 'gap-1.5 -ml-2 text-muted-foreground hover:text-foreground';

/**
 * Top-left back control returning to the project a report was deep-linked from.
 * Falls back to the ?reportProjectId= query param when no id is passed.
 */
export function BackToProjectLink({ projectId }: { projectId?: number | string | null }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const resolvedId = projectId ?? searchParams.get('reportProjectId');
  if (resolvedId === null || resolvedId === undefined || resolvedId === '') return null;

  return (
    <div className="print:hidden">
      <Button
        variant="ghost"
        size="sm"
        className={BACK_NAV_CLASSES}
        onClick={() => navigate(ROUTES.PROJECT_DETAILS(resolvedId))}
      >
        <StepBack className="h-4 w-4" />
        Back to Project
      </Button>
    </div>
  );
}

/** Top-left back control clearing an in-report drill-down. */
export function BackToReportButton({
  onBack,
  label = 'Back to Report',
}: {
  onBack: () => void;
  label?: string;
}) {
  return (
    <div className="print:hidden">
      <Button variant="ghost" size="sm" className={BACK_NAV_CLASSES} onClick={onBack}>
        <StepBack className="h-4 w-4" />
        {label}
      </Button>
    </div>
  );
}

export { BACK_NAV_CLASSES };
